"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CalculatorOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2Z"/><path d="M22,8v3H10V8H22m1.5-2H8.5a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5v-6a.5.5,0,0,0-.5-.5Z"/><path d="M11,16H9a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M17,16H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M17,20H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M23,16H21a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M11,20H9a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M23,20H21a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M17,24H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M11,24H9a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/><path d="M23,24H21a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"/>';
var CalculatorOutlineSVG = function CalculatorOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.CalculatorOutlineSVG = CalculatorOutlineSVG;
CalculatorOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CalculatorOutlineSVG);
exports.default = _default;